<template>
    <div>

        <div class="bg-white shadow-lines sm:shadow-dreamy">

            <a id="step-amount" class="flex px-8 py-8 justify-between items-center" href="" @click.prevent="stepChange">
                <span class="w-8 mr-8">
                    <template v-if="complete">
                        <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="15" fill="#08A818"/><path d="M24.338 5.192L9.953 19.577l-5.286-5.285a.656.656 0 00-.928 0l-1.547 1.546a.656.656 0 000 .929l7.297 7.296a.656.656 0 00.928 0L26.813 7.667a.656.656 0 000-.928l-1.547-1.547a.656.656 0 00-.928 0z" fill="#fff"/></svg>
                    </template>
                    <template v-else>
                        <svg width="30" height="30" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="15" cy="15" r="14.5" stroke="#4A96D2"/><path d="M19.469 22v-2.5h-5.24l3.04-3.16c1.26-1.26 2.1-2.4 2.1-4.26 0-2.34-1.5-4.18-4.48-4.18-3.42 0-4.34 2.46-4.28 4.36h2.74c0-.7.28-1.74 1.54-1.74 1.02 0 1.6.66 1.6 1.7 0 1.02-.56 1.78-1.44 2.7l-4.44 4.64V22h8.86z" fill="#4A96D2"/></svg>
                    </template>
                </span>
                <span
                    :class="{ 'text-gray-300': disabled, 'text-black': !disabled }"
                    class="w-full text-xl font-platform tracking-wider"
                >Välj belopp</span>
                <span v-if="! open && ! disabled">
                    <span href="#" class="text-sm text-gray-400 underline hover:text-black">
                        Ändra
                    </span>
                </span>
            </a>

            <!-- Expanded -->
            <div class="pb-4 px-4 sm:pb-8 sm:px-8" v-if="open && ! loading">

                <div class="flex justify-between mb-8">

                    <div class="card-selectable-button tracking-tighter">
                        <input type="radio" id="amount-200" value="200" v-model="form.amount" @click="customAmountIsVisible = false">
                        <label class="py-2 px-4 whitespace-no-wrap border border-blue-600 text-blue-600 text-sm lg:text-base text-center rounded focus:outline-none mr-3" for="amount-200">200 kr</label>
                    </div>

                    <div class="card-selectable-button tracking-tighter">
                        <input type="radio" id="amount-500" value="500" v-model="form.amount" @click="customAmountIsVisible = false">
                        <label class="py-2 px-4 whitespace-no-wrap border border-blue-600 text-blue-600 text-sm lg:text-base text-center rounded focus:outline-none mr-3" for="amount-500">500 kr</label>
                    </div>

                    <div class="card-selectable-button tracking-tighter">
                        <input type="radio" id="amount-1000" value="1000" v-model="form.amount" @click="customAmountIsVisible = false">
                        <label class="py-2 px-4 whitespace-no-wrap border border-blue-600 text-blue-600 text-sm lg:text-base text-center rounded focus:outline-none mr-3" for="amount-1000">1000 kr</label>
                    </div>

                    <div class="card-selectable-button tracking-tighter">
                        <button
                            class="py-2 px-4 whitespace-no-wrap border border-blue-600 text-sm lg:text-base text-center rounded focus:outline-none focus:bg-blue-600 focus:text-white"
                            :class="{
                                'bg-blue-600': customAmountIsVisible,
                                'text-white': customAmountIsVisible,
                                'text-blue-600': !customAmountIsVisible
                            }"
                            @click="showCustomAmount()"
                        >
                            Valfritt
                        </button>
                    </div>

                </div>

                <div v-if="customAmountIsVisible" class="mb-8">
                    <CardInput label="Valfritt belopp" v-model="form.amount" />
                </div>

                <div class="text-center">
                    <card-button @click="next" :loading="saving">Till leverans</card-button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Event from "../event"
    import CardInput from "./CardInput"
    import _ from 'lodash'
    import CardButton from "./CardButton";

    export default {
        name: "Amount",
        components: {CardButton, CardInput},
        props: {
            open: {type: Boolean, default: false},
            loading: {type: Boolean, default: false},
            disabled: {type: Boolean, default: false},
            form: {},
        },
        data() {
            return {
                complete: false,
                customAmountIsVisible: false,
                saving: false,
            }
        },
        watch: {
            open: function(newValue) {
                this.saving = !newValue
            }
        },
        methods: {
            stepChange() {
                if (!this.disabled) {
                    this.$emit('step', 'amount')
                }
            },
            showCustomAmount() {
                this.customAmountIsVisible = true
                this.form.amount = ''
            },
            next() {
                let amount = parseInt(this.form.amount)

                if (amount > 0) {
                    this.saving = true
                    this.complete = true
                    this.$emit('completed', {
                        step: 'amount'
                    })
                } else {
                    alert('Vänligen välj ett belopp')
                }
            },
        }
    }
</script>

<style lang="scss">
    .card-selectable-button {
        position: relative;
        transition: all 300ms;

        input[type="radio"] {
            position: absolute;
            opacity: 0;
            right: 0;
            z-index: 100;
            transition: all 300ms;

            &:checked + label {
                background-color: #1D5091;
                color: #fff;
                border-color: #1D5091;
            }

            &:focus + label {
                background-color: #1D5091;
                color: #fff;
                border-color: #1D5091;
            }
        }

        label {
            display: block;
            cursor: pointer;
            /*text-transform: none;*/
            /*margin-bottom: 15px;*/
            /*font-weight: 600;*/
        }
}

</style>